import React from 'react'
import Header from "../inc/Header";
import menu_berhamporelodge from "../images/FOOD MENU.pdf";
import Muttoneidmubarak from "../images/mutton.jpg";
import "./Eidmenu.css";

function Eidmenu() {
  return (
    <div>
      <Header />

      <br />
      <br />
      <br />
      <div className="berhamporelodge">
        <center>
          <h1><b>Berhampore Lodge, Best Trusted Hotel in Berhampore, Laldighi </b></h1>
          <h3> <b>Berhampore Lodge </b></h3>
        </center>
      </div>



      <div className="album py-2">

        <div className="container">

          <div className="row">

            <div className="col-md-6 mt-3">




              <h4 className="card-text mb-0"> <b>Berhampore Lodge Present - Room, Restaurant, Bar, Banquet, Any Party Booking Available</b></h4>

              <p className="card-text">Best Hotel Berhampore, Laldighi Murshidabad -</p>

   <div className="d-flex justify-content-start align-items-center mb-3">
    <a href={menu_berhamporelodge} target="_blank" rel="noopener noreferrer">
            <button className='menudownload me-3'>Download Menu <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
  <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"/>
  <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
</svg></button></a>
                <a style={{color:"white"}} className="callbook"  href="tel: +91 9647374167"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg> Book Menu</a>
              
              
</div>
             

            </div>
            <br />
            <div className="col-md-6 mt-3">

              <img src={Muttoneidmubarak} className="card-img-top" alt="eidmubarakberhampore" />


              <div className="d-flex justify-content-between align-items-center">



              </div>

            </div>






          </div>


        </div>

      </div>
      <hr />

    </div>
  )
}

export default Eidmenu
